import { CarriersController } from "../controllers/carriers-controller";
import { Carrier } from "../models/carrier"
import { CarrierFilter } from "../models/carrier-filter"
import { BusyService } from "../services/busy-service";
import { WebApiService } from "../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { AppMessageService } from "../services/app-message-service";
import { DialogService } from "aurelia-dialog";
import { UpdateUserDialog } from "./dialogs/update-user-dialog";
import { PageMessageService } from "../services/page-message-service";
import { SimpleDialog } from "./dialogs/simple-dialog";
import { SecurityService } from "../services/security-service";

@singleton()
@autoinject()
export class TasksHome {

    public filter: "assigned_to_me" | "available_for_me" | "unassigned" | "all" = "assigned_to_me";
    public includeInactive: false;

    public async setFilter(filter) {
        this.filter = filter;
        await this.loadTasks();
        this.filteredTasks = this.getFilteredTasks(this.filter);
    }

    assignedToMeCount = 0;
    availableForMeCount = 0;
    unassignedCount = 0;
    tasks = [];
    filteredTasks: Array<any> = [];

    private getFilteredTasks(filter: "assigned_to_me" | "available_for_me" | "unassigned" | "all") {
        var filtered = this.tasks;

        //save search criteria
        //AureliaCookie.set('search.selectedMills', JSON.stringify(this.selectedMills), null);

        //carrier mill

        if (!filtered) return [];

        if (filter != "all") {
            filtered = filtered.filter((item: any) => {
                if (filter == "assigned_to_me")
                    return item.assignedTo.value == this.securityService.user.id;
                if (filter == "unassigned"){
                    return !item.assignedTo.value;
                }
                if (filter == "available_for_me")
                    return true;
            });
        }
        return filtered;
    }

    public canSeeAllTasks: boolean;

    constructor(
        private securityService: SecurityService,
        private busyService: BusyService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService) {
    }
    

    async activate(params) {
        var contractsAndInsuranceLeadsGroupId = "a86a7675-52ab-401e-b8a2-aaca50c7ffdc";
        const isContractsAndInsuranceLeadsMember = this.securityService.hasGroup(contractsAndInsuranceLeadsGroupId);
        this.canSeeAllTasks = isContractsAndInsuranceLeadsMember || this.securityService.hasRole("Admin");
        AureliaCookie.set('nav_stack', 'tasks', {});
        await this.initializePage();
    }

    async refresh() {
        this.initializePage();
    }

    async initializePage() {
        await this.loadTasks();
        this.setFilter(this.filter);
        //await this.loadUserRequests();
    }

    async loadTasks() {
        this.busyService.on();
        try {
            var result;
            if (this.filter == "all") {
                result = await this.api.get("Tasks", "GetAllTasks", { includeInactive: this.includeInactive });
            } else {
                result = await this.api.get("Tasks", "GetTasksHomeScreenData", { includeInactive: this.includeInactive });
            }
            this.tasks = JSON.parse(result.response);
            this.assignedToMeCount = this.getFilteredTasks("assigned_to_me").length;
            this.unassignedCount = this.getFilteredTasks("assigned_to_me").length;
            this.availableForMeCount = this.getFilteredTasks("available_for_me").length;
        } finally {
            this.busyService.off();
        }
    }

    //saveDivision() {
    //    this.busyService.on();
    //    try {
    //        this.api.post("Divisions", "UpdateDivision", this.selectedDivision);
    //        this.appMessageService.addSuccessMessage("Division updated");
    //    } catch (e) {
    //        alert("Error saving division: " + e);
    //    } finally {
    //        this.busyService.off();
    //    }
    //}

}